import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { TuiButton, TuiHint } from '@taiga-ui/core';
import { PolymorpheusTemplate, PolymorpheusOutlet } from '@taiga-ui/polymorpheus';

import { SidePageComponent } from './sidepage.component';

@NgModule({
  imports: [
    TuiButton,
    PolymorpheusTemplate,
    PolymorpheusOutlet,
    CommonModule,
    TranslatePipe,
    ...TuiHint,
  ],
  declarations: [SidePageComponent],
  exports: [SidePageComponent],
})
export class SidePageModule {}
